import { Button } from 'react-bootstrap';
import { CaretRightFill } from 'react-bootstrap-icons';

interface Props {
  onClick: () => void;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
}

const NextButton: React.FC<Props> = ({ onClick, disabled = false, type = 'button', className = 'm-10' }) => {
  return (
    <Button variant="success" type={type} disabled={disabled} onClick={onClick} className={className}>
      次へ
      <CaretRightFill className="button-right-icon" />
    </Button>
  );
};

export default NextButton;
